import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
import {
    Dic
} from '$utils'
export const tableOption = function () {
    return {
        add: '新增',
        edit: '修改',
        view: '查看',
        page: true,
        selection: false,
        index: true,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: true,
        editBtn: false,
        delBtn: false,
        viewFormSlot: true,
        labelSuffix: '：',
        labelPosition: 'right',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '140px',
        menuAlign: 'center',
        searchMenuSpan: 6,
        searchBtn: false,
        dialogHeight: 400,
        dialogWidth: '700px',
        emptyText: '暂无数据',
        column: [{
                label: '出入口名称',
                prop: 'sceneName',
                align: 'right',
                search: true,
                addDisplay: true,
                editDisplay: false,
                editDisabled: false,
                viewDisplay: false,
                overHidden: true
            },
            {
                label: '出入口位置',
                prop: 'location',
                search: true,
                align: 'right',
                hide: false,
                addDisplay: true,
                editDisplay: false,
                viewDisplay: false,
                editDisabled: false,
                overHidden: true,
                span: 12
            },
            {
                label: '语音对讲',
                prop: 'deviceSceneCount',
                hide: false,
                search: false,
                addDisplay: true,
                editDisplay: false,
                viewDisplay: false,
                span: 12,
                align: 'right',
                formatter: function (row, value) {
                    return value.broadcastCount > 0 ? '√' : '-'
                }
            },
            {
                label: '车辆道闸',
                prop: 'deviceSceneCount',
                hide: false,
                search: false,
                searchSlot: false,
                addDisplay: true,
                editDisplay: false,
                viewDisplay: false,
                span: 12,
                align: 'right',
                formatter: function (row, value) {
                    return value.vehiclebarrierCount > 0 ? '√' : '-'
                }
            },
            {
                label: '人行道闸',
                prop: 'deviceSceneCount',
                hide: false,
                addDisplay: true,
                editDisplay: false,
                viewDisplay: false,
                viewslot: true,
                span: 12,
                align: 'right',
                formatter: function (row, value) {
                    return value.turnstilegateCount > 0 ? '√' : '-'
                }

            },
            {
                label: '经度',
                prop: 'longitude',
                hide: true,
                search: false,
                searchSlot: false,
                addDisplay: true,
                editDisplay: false,
                viewDisplay: false,
                span: 12,
                align: 'right',
            },
            {
                label: '纬度',
                prop: 'latitude',
                hide: true,
                search: false,
                searchSlot: false,
                addDisplay: true,
                editDisplay: false,
                viewDisplay: false,
                span: 12,
                align: 'right',
            },
        ]
    }

}